export enum TypeOfRequestOptionId {
  WITHDRAWAL = 'withdrawal',
  WITHDRAWAL_DELETION = 'withdrawalAndDeletion',
}
